import apiService from '../apiService';

// =========================
// 推薦使用的新版 API
// =========================

/**
 * 取得所有等級完整設定列表（分頁）
 * @param {Object} params - 查詢參數
 * @param {number} params.page - 頁碼
 * @param {number} params.per_page - 每頁筆數
 * @param {string} params.sort - 排序欄位 (level, required_exp, created_at, updated_at)
 * @param {string} params.order - 排序方向 (asc, desc)
 * @returns {Promise} API 響應
 */
export const getLevelConfigs = async (params = {}) => {
    const url = '/api/admin/level-setting/configs';
    return apiService.GET(url, params);
};

/**
 * 新增整合等級設定 (含限制與獎勵)
 * @param {Object} data - 等級設定資料
 * @param {Object} data.level - 等級基本資料
 * @param {number} data.level.level - 等級數字
 * @param {number} data.level.required_exp - 所需經驗值
 * @param {string} data.level.unlock_description - 解鎖說明
 * @param {Array} data.identities - 身份限制
 * @param {Array} data.rank_ids - 聘階限制ID
 * @param {Array} data.requirements - 升級條件
 * @param {Array} data.rewards - 升級獎勵
 * @returns {Promise} API 響應
 */
export const createLevelConfig = async (data) => {
    const url = '/api/admin/level-setting/config';
    return apiService.POST(url, data);
};

/**
 * 取得等級完整設定 (限制與獎勵)
 * @param {number} id - 等級 ID
 * @returns {Promise} API 響應
 */
export const getLevelConfig = async (id) => {
    const url = `/api/admin/level-setting/${id}/config`;
    return apiService.GET(url);
};

/**
 * 整合設定等級限制與獎勵
 * @param {number} id - 等級 ID
 * @param {Object} data - 等級設定資料
 * @param {Object} data.level - 等級基本資料
 * @param {number} data.level.level - 等級數字
 * @param {number} data.level.required_exp - 所需經驗值
 * @param {string} data.level.unlock_description - 解鎖說明
 * @param {Array} data.identities - 身份限制
 * @param {Array} data.rank_ids - 聘階限制ID
 * @param {Array} data.requirements - 升級條件
 * @param {Array} data.rewards - 升級獎勵
 * @returns {Promise} API 響應
 */
export const updateLevelConfig = async (id, data) => {
    const url = `/api/admin/level-setting/${id}/config`;
    return apiService.PUT(url, data);
};

/**
 * 取得配置選項（升級條件與獎勵）
 * @param {Object} params - 查詢參數
 * @param {string} params.category - 分類 (requirements, rewards)
 * @param {string} params.type - 類型（需搭配 category 使用）
 * @returns {Promise} API 響應
 */
export const getLevelConfigOptions = async (params = {}) => {
    const url = '/api/admin/level-setting/config-options';
    return apiService.GET(url, params);
};

/**
 * 刪除等級設定
 * @param {number} id - 等級 ID
 * @returns {Promise} API 響應
 */
export const deleteLevel = async (id) => {
    const url = `/api/admin/levels/${id}`;
    return apiService.DELETE(url);
};

/**
 * 取得等級異動記錄
 * @param {Object} params - 查詢參數
 * @param {number} params.user_id - 用戶 ID (可選)
 * @param {string} params.upgraded_from - 升級開始日期 (YYYY-MM-DD) (可選)
 * @param {string} params.upgraded_to - 升級結束日期 (YYYY-MM-DD) (可選)
 * @param {number} params.page - 頁碼
 * @param {number} params.per_page - 每頁筆數
 * @returns {Promise} API 響應
 */
export const getLevelLogs = async (params = {}) => {
    const url = '/api/admin/logs/level';
    return apiService.GET(url, params);
};

// =========================
// 已棄用的舊版 API (僅供向後相容)
// =========================

/**
 * 取得等級設定列表 (已棄用，建議使用 getLevelConfigs)
 * @deprecated 請使用 getLevelConfigs 替代
 * @param {Object} params - 查詢參數
 * @returns {Promise} API 響應
 */
export const getLevels = async (params = {}) => {
    const url = '/api/admin/levels';
    return apiService.GET(url, params);
};

/**
 * 新增等級設定 (已棄用，建議使用 createLevelConfig)
 * @deprecated 請使用 createLevelConfig 替代
 * @param {Object} data - 等級設定資料
 * @returns {Promise} API 響應
 */
export const createLevel = async (data) => {
    const url = '/api/admin/levels';
    return apiService.POST(url, data);
};

/**
 * 取得單一等級設定 (已棄用，建議使用 getLevelConfig)
 * @deprecated 請使用 getLevelConfig 替代
 * @param {number} id - 等級 ID
 * @returns {Promise} API 響應
 */
export const getLevelDetail = async (id) => {
    const url = `/api/admin/levels/${id}`;
    return apiService.GET(url);
};

/**
 * 更新等級設定 (已棄用，建議使用 updateLevelConfig)
 * @deprecated 請使用 updateLevelConfig 替代
 * @param {number} id - 等級 ID
 * @param {Object} data - 等級設定資料
 * @returns {Promise} API 響應
 */
export const updateLevel = async (id, data) => {
    const url = `/api/admin/levels/${id}`;
    return apiService.PUT(url, data);
};
